import { render, staticRenderFns } from "./user-modal.vue?vue&type=template&id=2e715960"
import script from "./user-modal.vue?vue&type=script&lang=js"
export * from "./user-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports